import React, { memo } from 'react';

import { Menu } from '@headlessui/react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './Dropdown.module.css';
import { tasksInformationActions } from '../../../../entities/task/model/slice/tasksInformation';
import { useAppDispatch } from '../../../../store';

interface DropdownProps {
    classes?: string;
    children: React.ReactNode;
}

export const Dropdown = memo(({ classes, children }: DropdownProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const onChangeSort = (value: boolean) => () => {
        // event.stopPropagation();
        dispatch(tasksInformationActions.changeSort(value));
    };
    return (
        <Menu>
            <Menu.Button
                onClick={(event) => {
                    event.stopPropagation();
                }}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}
                className={cn(cls.menu, classes)}
            >
                {children}
            </Menu.Button>
            <Menu.Items className={cls.menuItems}>
                <Menu.Item className={cls.item}>
                    <span className="opacity-75" onClick={onChangeSort(false)}>
                        {t('Features.Dropdown.MenuItem.Old.text')}
                    </span>
                </Menu.Item>
                <Menu.Item className={cls.item}>
                    <span className="opacity-75" onClick={onChangeSort(true)}>
                        {t('Features.Dropdown.MenuItem.New.text')}
                    </span>
                </Menu.Item>
            </Menu.Items>
        </Menu>
    );
});
